<template>
  <base-page-learning-unit-info
    mode="instructor"
    :disabled="disabled"
    :editable="editable"
  ></base-page-learning-unit-info>
</template>

<script>
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';
import BasePageLearningUnitInfo from './BasePageLearningUnitInfo';

export default {
  components: {
    BasePageLearningUnitInfo
  },

  mixins: [learningUnitInfoMixin],

  computed: {
    disabled() {
      return (
        this.learningUnit?.required_review ||
        this.learningUnit?.is_published ||
        !this.$currentUser.isOwnerOf(this.learningUnit?.id)
      );
    },
    editable() {
      const isDraft = !this.learningUnit?.is_published;
      const isRequiredReview = this.learningUnit?.required_review;
      const isOwner = this.$currentUser.isOwnerOf(this.learningUnit?.id);

      // can edit 'generalInfo', 'method' and 'learning' when
      // - is owner
      // - is draft
      // - is not required review
      return {
        generalInfo: isOwner && isDraft && !isRequiredReview,
        method: isOwner && isDraft && !isRequiredReview,
        learning: isOwner && isDraft && !isRequiredReview
      };
    }
  }
};
</script>
